import type { RouteLocationNormalized } from '#vue-router'

export default function (route: RouteLocationNormalized) {
  if (!route.params?.makeSlug) return ''
  return `${route.params.makeSlug}${route.params.modelSlug ? `/${route.params.modelSlug}` : ''}`
}
